import { RSAA } from 'redux-api-middleware';

export const FETCH_HELP_SUMMARY_REQUEST =
  '@@dashboard/FETCH_HELP_SUMMARY_REQUEST';
export const FETCH_HELP_SUMMARY_SUCCESS =
  '@@dashboard/FETCH_HELP_SUMMARY_SUCCESS';
export const FETCH_HELP_SUMMARY_FAILURE =
  '@@dashboard/FETCH_HELP_SUMMARY_FAILURE';

export const fetch_help_summary = () => ({
  [RSAA]: {
    endpoint: `/api/gis/help/summary/`,
    method: 'GET',
    types: [
      FETCH_HELP_SUMMARY_REQUEST,
      FETCH_HELP_SUMMARY_SUCCESS,
      FETCH_HELP_SUMMARY_FAILURE
    ]
  }
});
